module.exports = __webpack_public_path__ + "img/img29.ed8a0b65.svg";